import {LitElement, html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
//import { __ } from '@wordpress/i18n';

type Theme = 'system' | 'dark' | 'light';

@customElement( 'im-theme-switch' )
export class ThemeSwitch extends LitElement {

  @property( { attribute: 'dropdown-id' } )
  dropdownId: string = 'theme-switch-dropdown';

  @state()
  protected _currentTheme: Theme;

  @state()
  protected _iconClass: string = '';

  constructor() {
    super();
    this._detectTheme();
  }

  createRenderRoot() {
    return this;
  }
  
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener( 'infonews_theme_changed', this._handleThemeChanged );
  }

  disconnectedCallback() {
    window.removeEventListener( 'infonews_theme_changed', this._handleThemeChanged );
    super.disconnectedCallback();
  }

  private _handleThemeChanged = ( e: Event ) => {
    if ( e.target !== this ) {
      console.log('_handleThemeChanged in ', this.dropdownId);
      this._detectTheme();
      //this._applyComponentStyles();
    }
  }

  private _applyThemeStyles() {
    console.log( '_applyThemeStyles()' );

    this._applyComponentStyles();
    this._applyDocumentStyles();
  }

  private _applyComponentStyles() {
    if ( this._currentTheme == 'system' ) {
      if ( window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this._iconClass = 'fa-regular fa-moon-stars';
      }
      else {
        this._iconClass = 'fa-regular fa-sun';
      }
    }
    else if ( this._currentTheme == 'dark' ) {
      this._iconClass = 'fa-regular fa-moon-stars';
    }
    else {
      this._iconClass = 'fa-regular fa-sun';
    }
  }

  private _applyDocumentStyles() {
    if ( this._currentTheme == 'system' ) {
      if ( window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add( 'dark' );
      }
      else {
        document.documentElement.classList.remove( 'dark' );
      }
    }
    else if ( this._currentTheme == 'dark' ) {
      document.documentElement.classList.add( 'dark' );
    }
    else {
      document.documentElement.classList.remove( 'dark' );
    }
  }

  private _onClickItem( e: Event ) {
    const newRawTheme = (e.target as HTMLElement).dataset.theme;

    if ( newRawTheme ) {
      this._setTheme( newRawTheme as Theme );  
    }
    else {
      this._setTheme( 'system' );
    }

    const event = new Event( 'infonews_theme_changed', {bubbles: true, composed: true});
    this.dispatchEvent( event );
  }

  private _setTheme( newTheme: Theme ) {
    console.log( 'setTheme()', newTheme );

    // Set the theme for this ThemeSwitch component
    this._currentTheme = newTheme;

    // Set the theme for the whole page (LocalStorage)
    if ( this._currentTheme ) {
      localStorage.theme = this._currentTheme;
    }
    else {
      localStorage.removeItem( 'theme' );
    }

    this._applyThemeStyles();
  }

  private _detectTheme() {
    console.log( '_detectTheme' );

    if ( 'theme' in localStorage ) {
      if ( localStorage.theme === 'dark' ) {
        this._setTheme( 'dark' );
      }
      else if ( localStorage.theme === 'light' ) {
        this._setTheme( 'light' );
      }
      else {
        this._setTheme( 'system' );
      }
    }
    else {
      this._setTheme( 'system' );
    }
  }

  private _renderButton() {
    return html`
      <button data-dropdown-toggle="${ this.dropdownId }" class="dark-mode-toggle btn-circle btn-circle_in-header" title="Cambiar modo claro/oscuro">
        <i class="${this._iconClass}"></i>
      </button>
    `;
  }

  private _renderDropdown() {
    return html`
      <div id="${ this.dropdownId }" class="hidden rounded py-1 shadow bg-light-card-background dark:bg-dark-card-background absolute right-0 min-w-[160px] overflow-hidden">
        <button
          class="px-4 py-1 flex items-center w-full text-sm text-left text-light-meta dark:text-dark-meta hover:bg-gray-100 dark:hover:bg-zinc-800"
          @click="${this._onClickItem}"
          data-theme="light"
        >
          <i class="w-6 h-6 mr-2 !flex items-center justify-center fa-regular fa-sun"></i> Claro
        </button>
        
        <button
          class="px-4 py-1 flex items-center w-full text-sm text-left text-light-meta dark:text-dark-meta hover:bg-gray-100 dark:hover:bg-zinc-800"
          @click="${this._onClickItem}"
          data-theme="dark"
        >
          <i class="w-6 h-6 mr-2 !flex items-center justify-center fa-regular fa-moon-stars"></i> Oscuro
        </button>
        
        <button
          class="px-4 py-1 flex items-center w-full text-sm text-left text-light-meta dark:text-dark-meta hover:bg-gray-100 dark:hover:bg-zinc-800"
          @click="${this._onClickItem}"
          data-theme="system"
        >
          <i class="w-6 h-6 mr-2 !flex items-center justify-center fa-regular fa-tv"></i> Sistema
        </button>
      </div>
    `;
  }

  // Render the UI as a function of component state
  render() {
    return html`
      <div class="relative">
        ${this._renderButton()}
        ${this._renderDropdown()}
      </div>
    `;
  }
}
